module.exports = __webpack_public_path__ + "img/logo.51c34df9.png";